import { Grid_Item_default } from "./chunk-64YIOBIJ.js";
import { Grid_default } from "./chunk-UD3SWGAK.js";

// src/elements/Grid/index.ts
var GridComponent = Grid_default;
GridComponent.Item = Grid_Item_default;
GridComponent.Item.displayName = "Grid.Item";
export { GridComponent };